import { useIsMutating } from '@tanstack/react-query'

import { LoadingButton } from '@fortem-monorepo/react-ui'

import { chartEmailMutationKey, useEmailAccruedBalanceChart } from '@/react-query/mutations/accrued-interests'
import { useAccruedBalanceChart } from '@/react-query/queries/accrued-interests'

import { useAccruedInterestsContext } from '../AccruedInterests.context'

/** Send the current server snapshot once, including across tab unmounts/remounts. */
export const EmailChartButton = () => {
  const { params, chartInstrumentId } = useAccruedInterestsContext()
  const query = useAccruedBalanceChart({ fund_name: params.fund_name, instrument_id: chartInstrumentId })
  const email = useEmailAccruedBalanceChart()
  const emailPending = useIsMutating({ mutationKey: chartEmailMutationKey }) > 0
  const history = query.data
  const hasData = history && (history.points.length || history.coupon_dates.length || history.trades.length)
  const emailChart = async () => {
    if (!history || query.isFetching || emailPending || email.isPending) return
    try {
      await email.mutateAsync({
        fund_name: params.fund_name,
        instrument_id: history.instrument.instrument_id,
        revision: history.revision,
      })
    } catch {
      // The mutation reports errors; email outcomes are never retried automatically.
    }
  }
  return (
    <LoadingButton
      size="sm"
      disabled={!hasData || query.isFetching || query.isError || emailPending || email.isPending}
      title="Email all balance, coupon and trade datapoints, including every grid page, to your account email address."
      onClick={emailChart}
    >
      Email all datapoints to me
    </LoadingButton>
  )
}
